export default "__VITE_ASSET__CNCXsoBr__"